<template>
    <div class="xialakuang">
        <div :class="selectIdx==index? 'xialaBox select':'xialaBox'" v-for="(item,index) in list" :key="item.id" @click.stop="selected(index,item.name)">{{item.name}}</div>
    </div>
</template>

<script>
export default {
    props:['list'],
    data(){
        return {
            selectIdx:''
        }
    },
    methods:{
        selected(idx,name){
            this.selectIdx = idx
            let obj = {
                flag : false,
                name : name
            }
            this.$emit('hiddenList',obj)
        }
    }
}
</script>

<style lang="less" scoped>
    .xialakuang{
        width: 100%;
        height: 100%;
        .xialaBox{
            height: 48rem;
            line-height: 48rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            color: #666;
            font-size: 18rem;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .select{
            color: #0D94FF;
        }
    }
</style>